module.exports = __webpack_public_path__ + "img/users.cf2f36eb.svg";